export default __webpack_public_path__ + "static/session1-4fce73328fd5425e26fdc79975e021ab.png";